import * as React from 'react';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import { TextField, Chip, Paper, Box } from '@material-ui/core';
import { SelectPlayerPopup } from '../players/selectPlayerPopup';
import { PlayerRankings, LeagueMatchSubstitutesViewModel, LeagueMatchSubstitute, LeagueMatchSubstitutePlayerViewModel } from "../../api/api";
import { AbilityContext } from '../../common/users';
const CustomAutocomplete = withStyles({
    root: {
        width: 200,
        padding: 10
    },
    tag: {
        backgroundColor: "#a0a",
        height: 24,
        position: "relative",
        zIndex: 0,
        "& .MuiChip-label": {
            color: "#fff"
        },
        "& .MuiChip-deleteIcon": {
            color: "red"
        },
        "&:after": {
            content: '""',
            right: 10,
            top: 6,
            height: 12,
            width: 12,
            position: "absolute",
            backgroundColor: "white",
            zIndex: -1
        }
    }
})(Autocomplete);
const useStyles = makeStyles((theme) => createStyles({
    root: {
        //display: 'flex',
        display: 'block',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        paddingTop: 10
    },
    chip: {
        margin: theme.spacing(0.5),
    },
}));
class ChipData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this)[property] = (data)[property];
            }
        }
    }
}
const AutocompleteWithChips = (params) => {
    const classes = useStyles();
    return (React.createElement("div", null,
        React.createElement(CustomAutocomplete, { size: "small", options: params.options, getOptionLabel: (option) => option.name, onChange: params.onChange, renderInput: (inpParams) => React.createElement(TextField, Object.assign({}, inpParams, { label: "V\u00E6lg reserverspiller", key: params.key, variant: "outlined" })), className: "printHide" }),
        params.chipsArray.length > 0 &&
            React.createElement(Paper, { component: "ul", className: classes.root }, params.chipsArray.map((data) => {
                let icon;
                return (React.createElement("li", { key: data.reservePlayer.playerID },
                    React.createElement(Box, { displayPrint: "none", className: "printHide" },
                        React.createElement(Chip, { icon: icon, label: (React.createElement("section", null,
                                React.createElement("div", null,
                                    data.reservePlayer.playerNumber,
                                    " ",
                                    data.reservePlayer.name,
                                    " for"),
                                React.createElement("div", null,
                                    data.reserveForPlayer.playerNumber,
                                    " ",
                                    data.reserveForPlayer.name))), onDelete: params.onDeleteChip(data), className: classes.chip })),
                    React.createElement(Box, { display: "none", displayPrint: "block" },
                        React.createElement("section", null,
                            React.createElement("div", null,
                                data.reservePlayer.playerNumber,
                                " ",
                                data.reservePlayer.name,
                                " for"),
                            React.createElement("div", null,
                                data.reserveForPlayer.playerNumber,
                                " ",
                                data.reserveForPlayer.name)))));
            }))));
};
export const AddReservePlayers = props => {
    const ability = React.useContext(AbilityContext);
    const [open, setOpen] = React.useState(false);
    const [autoCompleteTextFieldKey, setEmptyAutoCompletes] = React.useState(new Date());
    const [selectedTeamId, setSelectedTeamId] = React.useState(0);
    const [teamPlayersToPopup, setTeamPlayersToPopup] = React.useState(props.match.team1Players);
    const [teamPlayersToAutocomplete, setTeamPlayersToAutocomplete] = React.useState({
        [props.match.match.leagueGroupTeamId1]: props.match.team1Players,
        [props.match.match.leagueGroupTeamId2]: props.match.team2Players,
    });
    const [selectedPlayer, setSelectedPlayer] = React.useState(new PlayerRankings({ playerID: 0, playerNumber: '', name: '', gender: '' }));
    const match = props.match.match;
    const chipDataFromProps = () => props.match.substitutes.map((substitute) => {
        return new ChipData({
            reservePlayer: new PlayerRankings({
                playerID: substitute.player1.playerId, playerNumber: substitute.player1.playerNumber, name: substitute.player1.name, gender: ''
            }),
            reserveForPlayer: new PlayerRankings({
                playerID: substitute.substitutedPlayer.playerId, playerNumber: substitute.substitutedPlayer.playerNumber, name: substitute.substitutedPlayer.name, gender: ''
            }),
            teamId: substitute.substitute.leagueGroupTeamId
        });
    });
    const [selectedReservePlayers, setSelectedReservePlayers] = React.useState(chipDataFromProps());
    React.useEffect(() => {
        setSelectedReservePlayers(chipDataFromProps());
    }, [props.match.substitutes]);
    const onAutocompleteChange = (selectedPlayer, teamPlayers, teamId) => {
        if (!selectedPlayer)
            return;
        let players = teamPlayers.filter((player) => player.playerID !== selectedPlayer.playerID);
        setSelectedPlayer(selectedPlayer);
        setTeamPlayersToPopup(players);
        setSelectedTeamId(teamId);
        setOpen(true);
    };
    const handleClose = () => {
        setEmptyAutoCompletes(new Date());
        setOpen(false);
    };
    const updateTeamPlayersInAutocomplete = (teamId) => {
        const teamPlayers = teamId === props.match.match.leagueGroupTeamId1 ? props.match.team1Players : props.match.team2Players;
        teamPlayersToAutocomplete[teamId] = teamPlayers.filter((player) => {
            var addedPlayer = selectedReservePlayers.filter((reservePlayer) => reservePlayer.reservePlayer.playerID === player.playerID);
            if (!addedPlayer || addedPlayer.length === 0)
                return player;
        });
        setTeamPlayersToAutocomplete(teamPlayersToAutocomplete);
        setEmptyAutoCompletes(new Date());
    };
    const selectedPlayerFromChildren = (player) => {
        selectedReservePlayers.push({ reservePlayer: selectedPlayer, reserveForPlayer: player, teamId: selectedTeamId });
        setSelectedReservePlayers(selectedReservePlayers);
        updateTeamPlayersInAutocomplete(selectedTeamId);
        updateParentState(selectedReservePlayers);
        handleClose();
    };
    React.useEffect(() => {
        if (selectedTeamId !== 0)
            updateTeamPlayersInAutocomplete(selectedTeamId);
    }, [selectedReservePlayers]);
    const handleReservePlayerDelete = (chipToDelete) => () => {
        let teamId;
        const chipData = ((chips) => {
            const newChips = chips.filter((chip) => {
                if (chip.reservePlayer.playerID !== chipToDelete.reservePlayer.playerID)
                    return chip;
                else
                    teamId = chip.teamId;
            });
            setSelectedTeamId(teamId);
            return newChips;
        })(selectedReservePlayers);
        setSelectedReservePlayers(chipData);
        updateParentState(chipData);
    };
    const updateParentState = (chipData) => {
        const stateModel = [];
        chipData.map((chip) => {
            stateModel.push(new LeagueMatchSubstitutesViewModel({
                substitute: new LeagueMatchSubstitute({
                    leagueMatchId: props.match.match.leagueMatchId, playerId: chip.reservePlayer.playerID, substitutedPlayerId: chip.reserveForPlayer.playerID, leagueGroupTeamId: chip.teamId
                }),
                player1: new LeagueMatchSubstitutePlayerViewModel({
                    name: chip.reservePlayer.name,
                    playerId: chip.reservePlayer.playerID,
                    playerNumber: chip.reservePlayer.playerNumber
                }),
                substitutedPlayer: new LeagueMatchSubstitutePlayerViewModel({
                    name: chip.reserveForPlayer.name,
                    playerId: chip.reserveForPlayer.playerID,
                    playerNumber: chip.reserveForPlayer.playerNumber
                })
            }));
        });
        props.setReservePlayersState(stateModel);
    };
    return (React.createElement("div", null,
        React.createElement("h4", null, "Reserver"),
        React.createElement("table", { className: "matchresultschema editmatch" },
            React.createElement("tbody", null,
                React.createElement("tr", { className: "toprow" },
                    React.createElement("td", null, match.teamName1),
                    React.createElement("td", null, match.teamName2)),
                React.createElement("tr", null,
                    React.createElement("td", { style: { verticalAlign: 'top' } },
                        React.createElement(AutocompleteWithChips, { options: teamPlayersToAutocomplete[props.match.match.leagueGroupTeamId1], key: autoCompleteTextFieldKey, onChange: (event, option) => onAutocompleteChange(option, props.match.team1Players, props.match.match.leagueGroupTeamId1), chipsArray: selectedReservePlayers.filter((chipData) => chipData.teamId === props.match.match.leagueGroupTeamId1), onDeleteChip: handleReservePlayerDelete })),
                    React.createElement("td", { style: { verticalAlign: 'top' } },
                        React.createElement(AutocompleteWithChips, { options: teamPlayersToAutocomplete[props.match.match.leagueGroupTeamId2], key: autoCompleteTextFieldKey, onChange: (event, option) => onAutocompleteChange(option, props.match.team2Players, props.match.match.leagueGroupTeamId2), chipsArray: selectedReservePlayers.filter((chipData) => chipData.teamId === props.match.match.leagueGroupTeamId2), onDeleteChip: handleReservePlayerDelete }))))),
        React.createElement(SelectPlayerPopup, { open: open, onClose: handleClose, playersList: teamPlayersToPopup, matchData: match, canChoosePlayers: true, selectedPlayer: selectedPlayerFromChildren, playerReplacementContext: true })));
};
